export const storeData = (query, data) => ({
  type: "STORE_DATA",
  query,
  data
})

const resolveApiUrl = (postURL) => {
  if (postURL) {
    return postURL
  }

  if (process.env.REACT_APP_API) {
    return process.env.REACT_APP_API
  }

  if (process.env.DEFAULT_SITE_URL) {
    return `${process.env.DEFAULT_SITE_URL.replace(/\/$/, "")}/api`
  }

  return null
}

export const fetchData = (query, key, postURL, fetchOptions = {}) => {
  const endpoint = key ? key : query
  const fetchUrl = resolveApiUrl(postURL)

  let headers = typeof window !== "undefined" && window.location.search.match(/\btoken=([^&]+)/) ? {
    "Content-Type": "application/json",
    "X-Craft-Token": window.location.search.match(/\btoken=([^&]+)/)[1]
  } : {
    "Content-Type": "application/json"
  }

  return (dispatch, getState) => {
    if (!fetchUrl) {
      console.log(`Skipping fetch for ${endpoint}: missing API URL (REACT_APP_API/DEFAULT_SITE_URL).`)
      dispatch(storeData(endpoint, null))
      return Promise.resolve(null)
    }

    return fetch(fetchUrl, {
      method: "POST",
      headers: headers,
      credentials: fetchOptions.credentials || "include",
      ...fetchOptions,
      body: query
    })
      .then(response => response.json())
      .then(response => {
        // console.log(response, endpoint)
        if (response.errors) {
          console.log(response, query)
        }
        dispatch(storeData(endpoint, response.data))
      })
      .catch(err => {
        console.log(query, err)
      })
  }
}
